import Card from "react-bootstrap/Card"
import "./style.css"
import { useEffect, useState } from "react";
import { ThreeDots } from 'react-loader-spinner'
import { Chart } from "./Chart"
import { getPLResponse } from "../../services/util/historicalComponentsResponses";
import { useSelector } from "react-redux";
import { getTotalHistoricalPlPercentageES } from "../../api/historicalEndPoints/equitySpotMultiday";
import moment from "moment";

export const PLCard = ({hetmapPlPoints, filterDropdownVersion, type, startandEndDate, heatmapVersion, asset, tradetype, currContractDiv, heatMapData }: any) => {

    const [plResponse, setPlResponse] = useState<any>([])
    const [loading, setLoading] = useState<any>(true)
    const [plPerRes, setPlPerRes] = useState<any>(null)

    const theme: any = useSelector((state: any) => {
        return state.theme.isTheme;
      })
    const getFontColorAsPerValue = (value: any) => {
    if (theme == 'light') {
        return value >= 0 ? 'darkgreen' : "red";
    }
    else if(theme=='dark'){
        return value >= 0 ? "lightgreen" : "orangered";
    }
    else if(theme=='b&w'){
        return value >= 0 ? 'lightgreen' : "orangered";
    }
}

// useEffect(()=>{
//     setPlPerRes(null)
//     if (heatMapData?.length > 0){
//         let pl_percent:any = 0
//         if (heatmapVersion == "all"){
//             heatMapData.forEach((element:any) => {
//                 if (element['pl_percentage']){
//                     pl_percent = Number(pl_percent) + Number(element['pl_percentage'])
//                 }
//             });
//             setPlPerRes(Number(pl_percent)/Number(heatMapData.length-1))
//         }
//         else{
//             let responseArr:any = heatMapData.filter((element:any)=>{return element['identifier'] == heatmapVersion}) 
//             responseArr.forEach((element:any) => {
//                 if (element['pl_percentage']){
//                     pl_percent = pl_percent + Number(element['pl_percentage'])
//                 }
//             });
//             setPlPerRes(pl_percent/responseArr.length)
//         }
//     }
// },[heatMapData,heatmapVersion])


useEffect(()=>{
    setPlPerRes(null)
    if (heatMapData?.length > 0){
        let pl_percent:any = 0
        if (heatmapVersion == "all"){
            // console.log("heatmapVersionALL", heatMapData[0]['asset'])
            if (heatMapData[0]['asset']== 'equityMultiday'){
                const getAllPl = async () => {
                let response:any = await getTotalHistoricalPlPercentageES(moment(startandEndDate?.start_date), moment(startandEndDate?.end_date).format('YYYY-MM-DD'),heatMapData[0]['asset'])
                if(response) setPlPerRes(response)
                console.log("112")}
            getAllPl()}
            if (heatMapData[0]['asset']== 'equityN50BANK'){
                const getAllPl = async () => {
                console.log("These are the inputs for getTotalHistoricalPlPercentageES", moment(startandEndDate?.start_date).format('YYYY-MM-DD'), moment(startandEndDate?.end_date).format('YYYY-MM-DD'),heatMapData[0]['asset'])
                let response:any = await getTotalHistoricalPlPercentageES(moment(startandEndDate?.start_date).format('YYYY-MM-DD'), moment(startandEndDate?.end_date).format('YYYY-MM-DD'),heatMapData[0]['asset'])
                console.log("This is the getAllPlResponse", response);
                
                if(response) setPlPerRes(response)
                console.log("113")}
            getAllPl()}
            else{
                if (heatMapData?.length === 1){
                    console.log("heatMapData", heatMapData[0].pl_percentage)
                    setPlPerRes(Number(heatMapData[0].pl_percentage))

                }
                else{
                heatMapData.forEach((element:any) => {
                if (element['pl_percentage']){
                    pl_percent = Number(pl_percent) + Number(element['pl_percentage'])
                }
                });
                setPlPerRes(Number(pl_percent)/Number(heatMapData.length-1))
                    console.log("114")
            }}
           
        }
        else{
            console.log("heatmapVersion", heatmapVersion)
            let responseArr:any = heatMapData.filter((element:any)=>{return element['identifier'] == heatmapVersion})
            responseArr.forEach((element:any) => {
                if (element['pl_percentage']){
                    pl_percent = pl_percent + Number(element['pl_percentage'])
                }
            });
            setPlPerRes(pl_percent/responseArr.length)
        }
    }
},[heatMapData,heatmapVersion, startandEndDate])


    useEffect(() => {
        if (startandEndDate !== null) {
            try {
                const fetchCallsResponse: any = async () => {
                    setPlResponse([])
                    setLoading(true)
                    let callsResponse: any = await getPLResponse(startandEndDate?.start_date, startandEndDate?.end_date, asset, heatmapVersion, type, tradetype, filterDropdownVersion)
                    setPlResponse(callsResponse)
                    setLoading(false)
                }
                fetchCallsResponse()
            } catch (error) {
                console.log("Excepction occured while calling the api for calls : ", error)
               
            } finally {
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startandEndDate, heatmapVersion, asset])

    return <>
        {loading ? <ThreeDots visible={true}
            height="60"
            width="60"
            color="#8eabc5"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass="" />
            :
            currContractDiv && ['stockindexOptIntraday'].includes(type) ?
            <Card className="custom-card card2 customCardHover" style={{ background: "transparent" }} data-hover={`${hetmapPlPoints?.toFixed(2)} pts`}>
                <div className="total_currContractDiv heading" style={{ display: "inline-block", marginTop: "-0.4rem" }}><img style={{ height: "2rem", marginRight: "1rem", width: "2rem", display: "inline-block" }} src="/images/pl.png" />PL  <span style={{ color: getFontColorAsPerValue(plResponse?.total) }}>{(plResponse?.total)?.toFixed(2)}</span></div>
            </Card>
            :currContractDiv || ['equityMultiday','equityN50BANK'].includes(type) ?
                <Card className={`${type === 'equityMultiday' || type === 'equityN50BANK' ? 'custom-card card2' : "custom-card card2 customCardHover"}`} style={{ background: "transparent" }} data-hover={`${hetmapPlPoints?.toFixed(2)} pts`}>
                    <div className="total_currContractDiv heading" style={{ display: "inline-block", marginTop: "-0.4rem" }}><img style={{ height: "2rem", marginRight: "1rem", width: "2rem", display: "inline-block" }} src="/images/pl.png" />Return  <span style={{ color: getFontColorAsPerValue(plPerRes)}}>{(plPerRes)?.toFixed(2)} %</span></div>
                </Card>
                : <Card className="custom-card card2">
                    <div className="total heading" style={{ display: "inline-block" }}><img style={{ height: "2rem", marginRight: "1rem", width: "2rem", display: "inline-block" }} src="/images/pl.png" alt="pl" />PL  <span style={{ color: getFontColorAsPerValue(plResponse?.total) }}>{(plResponse?.total)?.toFixed(2)}</span></div>
                    {!['equityMultiday','equityN50BANK'].includes(type)?
                        <>
                            <div className="months">
                                {plResponse?.data?.map((data: any, i: any) => {
                                    return <Card.Subtitle className="mb-2 " key={i}>{((data.month)?.slice(0, 3))?.toUpperCase()} {data.year} :
                                        {" "}<span style={{ color: getFontColorAsPerValue(data.value), fontWeight: 700 }}>{data?.value && (Number(data?.value)?.toFixed(2))}</span></Card.Subtitle>
                                })}
                            </div>
                            <Chart dataset={plResponse?.data} name="P / L" />
                        </> : ""}
                </Card>}
    </>
}